// src/lang/zh-TW.js （繁体中文）
export default {
    menu: {
        home: '首頁',
        about: '關於我們',
        aboutGroup: '集團介紹',
        corporateCulture: '品牌文化',
        brandHistory:'品牌歷程',
        brandPromotion:'品牌宣传',
        news:'集團新聞',
        productShowcase:'集團產品',
        teaSeries: '茶業系列',         // 茶业系列（泛指茶叶相关产品）
        teaDrinkSeries: '茶飲系列',  // 茶饮系列（强调饮品形态）
        teaSetSeries: '茶器系列',  // 茶器系列（茶具、器皿类）
        teaBanquetSeries: '茶宴系列', // 茶宴系列（茶主题宴席）
        teaCabinSeries: '茶艙系列',      // 茶舱系列（若指茶空间/仓储相关）
        groupControl: '集團管控',  // 集团管控
        jobRecruitment: '人才招募',  // 人才招纳（繁体中"招纳"常用"招募"表达，更符合习惯）
        socialResponsibility: '社會責任',  // 社会责任
        publicWelfare: '公益幫扶助力',        // 公益帮扶助力
        agricultureView: '三農優選計劃',     // 三农优选计划（"三农"为大陆术语，繁体中可直接使用，或根据受众调整为"農業、農村、農民"相关表述）
        villageView: '鄉村振興戰略',         // 乡村振兴战略
        healthyChina: '健康中國品牌',        // 健康中国品牌
        contact: '聯繫我們'                  // 联系我们
    },
    message: {
        langSwitchSuccess: '切換語言成功',
        langChinese: '已為您切換至中文繁體模式',
        // ... 其他提示文本
    },
    products: {
        title: '系列產品'  // 对应“系列产品”的键
    },
    AboutUsSection: {
        title: '構築百年企業    傳承荊楚文化',
        text: '三皮罐，源於荊楚民間傳統，承載著400年的文化記憶。相傳神農嘗百草時發現，三片海棠葉入罐沖泡，七日不餿，故得名「三皮罐」。這一獨特的茶飲文化，深深植根於荊楚大地，見證了代代相傳的生活智慧。',
        text2: '作為中國大健康產業品牌運營商，三皮罐集團積極響應「健康中國2030」戰略和「三茶統籌」理念，將茶文化、茶產業、茶科技深度融合，我們不止於做茶，更在締造一種健康、自然、可持續的生活方式，致力於打造具有荊楚特色的茶文化服務綜合體和多元化產業格局。',
        text3: '集團紮根荊楚，胸懷世界，在北京、上海、武漢、廣州、深圳、成都、重慶等城市設立城市辦公室，在香港設立國際中樞平台。以萬畝茶園為根基，依托優質水源，運用現代茶科技，建設智能化超級工廠、天下茶艙、源茶基地、天然水基地等重點項目。致力於將千年茶香與現代健康消費完美融合，以三皮罐茶、水、器、時、空五大產品線對話世界。'
    },
    AboutUsSectionStats: {
        farm: '種植基地',
        factory: '超級工廠',
        experience: '服務經驗',
        city: '覆蓋城市',
        unitMu: '畝',
        unitYear: '年',
        unitPlus: '+'
    },
    brandProText: {
        title: '三皮罐大健康', // 品牌名通常不变，或按繁体习惯微调
        slogan: '自然、健康、正能量',
        description: '三皮罐的魅力，在於它用最簡單的原料和工藝，詮釋了「大道至簡」的東方智慧。無論是傳統沖泡的質樸，還是現代罐裝的便捷，它始終以「天然、健康、回甘」為核心，既承載著四百年的文化記憶，又滿足著現代人們對健康品質生活的追求。正如三皮罐集團總經理鮮文亮所言：「我們不是在做飲料，而是在傳遞一種生活方式。」這種將自然、傳統與創新融為一體的特質，讓三皮罐成為一款值得品味、收藏和分享的「有故事的產品」。'
    },
    sectionRenewal: {
        title: '5X煥新而來', // “焕”繁化为“煥”，“来”繁化为“來”
        subtitle: '傳荊楚文脈 • 造健康生活' // “传”繁化为“傳”，“脉”繁化为“脈”
    },
    moreBtn:'瞭解更多',
    fiveXItems: [
        {
            title: '茶', // 单字不变
            relationship: '茶業', // “业”繁化为“業”
            icon: 'icon-chaye',
            description: '荊楚文化的味覺名片' // “荆”→“荊”，“觉”→“覺”
        },
        {
            title: '水',
            relationship: '茶飲', // “饮”繁化为“飲”
            icon: 'icon-chayin',
            description: '草本飲品中的驚喜' // “饮”→“飲”，“惊”→“驚”
        },
        {
            title: '器',
            relationship: '茶器',
            icon: 'icon-chaqi',
            description: '一罐傳千年' // “传”→“傳”
        },
        {
            title: '時', // “时”繁化为“時”
            relationship: '茶境',
            icon: 'icon-chajing',
            description: '荊楚茶韻的體驗高地' // “韵”→“韻”，“体”→“體”
        },
        {
            title: '空',
            relationship: '茶界',
            icon: 'icon-chajie',
            description: '生態空間矩陣' // “态”→“態”，“阵”→“陣”
        }
    ],
    EnterpriseNewsTitle:'企業動態',
    ViewDetails:'查看詳情',
    FooterBar: {
        title: '服務熱線',
        menuTitle: '關於我們',
        about: '集團介紹',
        Culture: '品牌文化',
        news: '新聞動態',
        qxtitle: '旗下產品',
        chaye: '茶業',
        chayin: '茶飲',
        chaqi: '茶器',
        chayan: '茶宴',
        chacang: '茶艙',
        responsibility: '責任與公益',
        publicWelfare: '公益之行',
        responsibilityView: '社會責任',
        Copyright: '版權所有 三皮罐大健康產業集團',
        siteMapView: '網站地圖',
        adminLogin: '管理登錄',
        ImageUploader: '上傳圖片'
    },
    proCultureImages: {
        culture1: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909694.png',
        culture2: 'https://pic1.imgdb.cn/item/68fb7ce73203f7be00988e67.png',
        culture3: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909696.png',
        culture4: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909699.png',
        culture5: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be0090969a.png'
    }

}
